import React, { useState, useEffect } from 'react'
import { Dialog, Table, toaster, Button, Heading } from 'evergreen-ui'
import RoundBtn from '../../Components/RoundBtn';
import ResourcesForm from './ResourcesForm';
import axios from '../../Utils/axios';
import { connect } from 'react-redux'
const Resources = ({
  company
}) => {

  const [isModalVisible, setVisibility] = useState(false)
  const [resources, setResources] = useState([])
  const [resourceEdit, setResourceEdit] = useState(null)

  const createOrEdit = (resource = null) => {
    setResourceEdit(resource)
    setVisibility(true)
  }

  const getResources = async () => {
    try {
      const { data } = await axios.get(`/company/resources`)
      setResources(data.resources)
    }
    catch (error) {
      toaster.danger('Falha ao Buscar dados')
    }
  }

  useEffect(() => {
    getResources()
  }, [])

  return (
    <React.Fragment>
      <Heading size={600} style={{ marginLeft: 10 }}> Recursos </Heading>
      <Table style={{ marginRight: 10, marginLeft: 10, marginTop: 20 }}>
        <Table.Head>
          <Table.TextHeaderCell>
            Descrição dos Recursos
          </Table.TextHeaderCell>
          <Table.TextHeaderCell>
            Status
          </Table.TextHeaderCell>
          <Table.TextHeaderCell>
            Requer km?
          </Table.TextHeaderCell>
          <Table.TextHeaderCell >
            Ações
          </Table.TextHeaderCell>
        </Table.Head>
        <Table.VirtualBody allowAutoHeight={true} height={600}>
          {resources.map(resource => (
            <Table.Row key={resource.__id__}>
              <Table.TextCell >{resource.name}</Table.TextCell>
              <Table.TextCell>{resource.active ? 'Ativo' : 'Inativo'}</Table.TextCell>
              <Table.TextCell>{resource.requiresMileage ? 'Sim': 'Não'}</Table.TextCell>
              <Table.TextCell>
                <Button
                  iconBefore='edit'
                  marginRight={10}
                  onClick={() => createOrEdit(resource)}
                > Editar </Button>
              </Table.TextCell>
            </Table.Row>
          ))}
        </Table.VirtualBody>

      </Table >
      <RoundBtn action={() => createOrEdit()} />

      <Dialog
        isShown={isModalVisible}
        title="Cadastro de Recursos"
        onCloseComplete={() => setVisibility(false)}
        hasFooter={false}
        shouldCloseOnOverlayClick={false}
      >
        <ResourcesForm
          edit={resourceEdit}
          close={(resource) => {
            setVisibility(false)
            if (!resource) {
              return getResources()
            }
            setResources([...resources, resource])
          }}
        />
      </Dialog>

    </React.Fragment >
  )
}
const mapStateToProps = ({ auth }) => ({
  company: auth.account.company
})

export default connect(mapStateToProps)(Resources)